import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25856b0a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/daterange-picker/_daterange-picker.scss?vue&type=style&index=0&id=25856b0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25856b0a",
  null
  
)

export default component.exports